module.exports = __webpack_public_path__ + "img/soraia.75453225.png";